import React from 'react'
import { QuoteBlockProps } from '@/components/molecules/QuoteBlock/types'
import { Image } from '@/components/atoms/Image/Image'
import { ReactComponent as BgCircleP } from '@/assets/icons/purple_full_circle.svg'
import { ReactComponent as BgCircleB } from '@/assets/icons/blue_small_full_circle.svg'

export function QuoteBlock({ quote, author, image, job_title }: QuoteBlockProps) {
  return (
    <article className="mx-24 tablet-xl:mx-0 p-24 tablet:p-40 bg-primary-100 rounded-xl mb-40 flex flex-col netbook:flex-row gap-24">
      <div className="netbook:pl-[22px] netbook:border-l-2 border-primary-500 flex flex-col gap-24 text-text-brand-darker font-sans">
        <p className="quote text-bodyL font-bold">{quote}</p>
        <div className="hidden netbook:flex flex-col w-fit mobile:flex-row items-center justify-center gap-8 mobile:gap-16 text-bodyS max-netbook:mx-auto">
          {author && <p>{author}</p>}
          <span className="bg-primary-500 size-8 rounded-full" />
          {job_title && <p>{job_title}</p>}
        </div>
      </div>
      <div className="relative">
        <BgCircleP className="hidden netbook:block absolute top-2/3 -translate-y-112 -right-4 rotate-3" />
        <BgCircleB className="hidden netbook:block absolute top-3/4 left-0 w-16" />
        <div className="flex gap-16 w-fit">
          {image.image ? (
            <Image
              fluid
              fixed={false}
              data={image}
              options={{ width: 200 }}
              className="size-64 netbook:size-200 mx-auto netbook:m-"
              imgClassName="rounded-full"
            />
          ) : (
            <div className="hidden netbook:block netbook:size-200 rounded-full" />
          )}
          <div className="flex flex-col justify-center gap-8 text-text-brand-darker font-sans text-bodyS netbook:hidden">
            {author && <p>{author}</p>}

            {job_title && <p>{job_title}</p>}
          </div>
        </div>
      </div>
    </article>
  )
}
